export default __webpack_public_path__ + "static/media/instalacion-colectiva-con-excedentes.42d73c9d.svg";